import { environment } from './../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { LocalStoreService } from './local-store.service';
import { Router } from '@angular/router';
import { of, Observable, timer } from 'rxjs';
import { delay, shareReplay, tap } from 'rxjs/operators';
import * as KJUR from 'jsrsasign';
import * as moment from 'moment';
import { NavigationService } from './navigation.service';
 
 @Injectable({
   providedIn: 'root'
 })
 export class AuthService {
   // Only for demo purpose
   authenticated = true;
 
   private defaultHttpOptions = {
     headers: new HttpHeaders({
       'Content-Type': 'application/json',
       'Accept' : 'application/json'
     })
   };
 
 
   constructor(
     private store: LocalStoreService,
     private router: Router,
     private http: HttpClient,
     private navigationService: NavigationService,
   ) {
     this.checkAuth();
   }
 
   checkAuth() {
     // this.authenticated = this.store.getItem("demo_login_status");
   }
 
   getuser() {
     return of({});
   }

   

   signingoogle(authtoken: any) {
 
 
    const oHeader = { alg: 'HS256', typ: 'JWT' };
    // Payload
    const oPayload: any = {};
    oPayload.token = authtoken;
    const sHeader = JSON.stringify(oHeader);
    const sPayload = JSON.stringify(oPayload);

    const sJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, 'Vbxq2mlbGJw8XH+ZoYBnUHmHga8/o/IduvU/Tht70iE=');
   //  if (isDevMode()) { console.log(`Encrypted JWT = ${sJWT}`); }
    return this.jwtLoginGoogle(sJWT).pipe(
      tap(
        response => {
         // if(isDevMode()) console.log(response);
          this.setSession(response);
        }
      ),
    );
  }

   signin(credentials: any) {
 
 
     const oHeader = { alg: 'HS256', typ: 'JWT' };
     // Payload
     const oPayload: any = {};
     oPayload.usuario = credentials.email;
     oPayload.contrasena = credentials.password;
     const sHeader = JSON.stringify(oHeader);
     const sPayload = JSON.stringify(oPayload);
 
     const sJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, 'Vbxq2mlbGJw8XH+ZoYBnUHmHga8/o/IduvU/Tht70iE=');
    //  if (isDevMode()) { console.log(`Encrypted JWT = ${sJWT}`); }
     return this.jwtLogin(sJWT).pipe(
       tap(
         response => {
          // if(isDevMode()) console.log(response);
           this.setSession(response);
         }
       ),
     );
   }
 
   signout() {
     localStorage.removeItem('token');
     localStorage.removeItem('token_type');
     localStorage.removeItem('expires_at');
    localStorage.removeItem('token_jwt');
     this.router.navigateByUrl('/sessions/ses/signin');
   }
 
   jwtLogin(token: string): Observable<any> {
     return this.http.post(`${environment.BACKEND_URL}/HS_Autenticar`, { jwt: token }, this.defaultHttpOptions);
   }
   jwtLoginGoogle(token: string): Observable<any> {
    return this.http.post(`${environment.BACKEND_URL}/HS_AutenticarGoogle`, { jwt: token }, this.defaultHttpOptions);
  }
   setSession(authResult: any) {
    if(!authResult)return;
        if(authResult.expires_in && authResult.token_type){
          const expires_at = moment().utc().add(authResult.expires_in, 'hour');
          localStorage.setItem('token', authResult.token);
          localStorage.setItem('token_type', authResult.token_type);
          localStorage.setItem('expires_at', JSON.stringify(expires_at.valueOf()));
        }else if(authResult.JWT){
          localStorage.setItem('token_jwt', authResult.JWT);
          localStorage.setItem('rol_id', authResult.rol);
          //timer(500).subscribe( _=> {window.location.reload()})
          timer(200).subscribe( _ =>{
            if(authResult.rol == 1){
              this.navigationService.publishNavigationChange('admin')
            }else{
              this.navigationService.publishNavigationChange('client')
            }
          })
        }
       }
       isLoggedIn() {
         return moment().utc().isBefore(this.getExpiration());
       }
       getExpiration() {
         
    if(
        localStorage.getItem('token') && 
        localStorage.getItem('token_type') && 
        localStorage.getItem('expires_at')
      ){
  
        const expiration = localStorage.getItem('expires_at');
        const expires_at = JSON.parse(expiration);
        return moment(expires_at);
  
      }else if(localStorage.getItem('token_jwt')){
  
        return moment().utc().add(1, 'hour');
        
      }else{
  
        return moment().utc().add(-1, 'hour');
  
      }
     }

    recoverPasswordAdm(email) {
      let headers = new HttpHeaders();
      headers = headers.set('Content-type', 'application/json');
      headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
      return this.http.post(`${environment.BACKEND_URL}` + '/HS_Usuario/recuperarPswd', { correo: email }, { headers: headers });
    }
   
    updatedPassRecover(pass, token){
      let headers = new HttpHeaders();
      headers = headers.set('Content-type', 'application/json');
      headers = headers.set('Authorization', 'Basic ' + btoa(token));
      return this.http.post(`${environment.BACKEND_URL}` + '/HS_Usuario/nuevoPswd', { jwt: pass }, { headers: headers });
    }
   
   }